import {
  PricePointTypes,
  SubscriptionComponentPriceStep,
} from '../../../models/component/types';

export const getPriceRange = (
  pricePointType: PricePointTypes,
  prices: SubscriptionComponentPriceStep[],
  currency: string
) => {
  if (!pricePointType || pricePointType === 'per_unit') {
    return {
      value: prices[0].priceInCents,
      currency,
    };
  }
  const pricesInCents = prices.map((price) => price.priceInCents);
  const min = Math.min(...pricesInCents);
  const max = Math.max(...pricesInCents);
  return {
    value: [min, max],
    currency,
  };
};
